/**
 * Tries to open the clients share feature. If not available, displays custom modal with the share buttons.
 *
 * @param {string} title
 * @param {string} text
 * @param {string} url
 */
export default function (title, text, url) {
    return {
        title,
        text,
        url,
        openFallback: function () {
            window.livewire.emit('socialShareModal@show');
        },
        open: function () {
            if (navigator.share) {
                navigator
                    .share({
                        title: this.title,
                        text: this.text,
                        url: this.url,
                    })
                    .catch((error) => {
                        if (error.name !== 'AbortError') {
                            this.openFallback();
                        }
                    });

                return;
            }

            this.openFallback();
        },
    };
}
